<template>
  <div class="house-page page">
    <van-swipe
      ref="swiperType"
      class="content-page-view"
      vertical
      :loop="false"
      :show-indicators="false"
      :width="clientWidth"
      @change="swiperTypeChange"
    >
      <van-swipe-item class="content-item">
        <div
          class="flx-col-ctr animated2s fadeIn"
        >
          <template
            v-if="pageType == PAGE_TYPE_LIST[0]"
          >
            <!-- 背景 -->
            <div
              class="abs flx-ctr animated0d5s delay0d5s fadeIn"
              style="width: 10rem;height: 100vh;"
            >
              <van-image
                :src="require('@/imgs/index/house/bg.png')"
                :show-error="false"
                :show-loading="false"
                width="10rem"
                class="show-bg"
                style="z-index: -1;margin-top: -24vh;"
              >
                <van-image
                  :src="require('@/imgs/index/house/label.png')"
                  :show-error="false"
                  :show-loading="false"
                  width="8.22rem"
                  class="abs show-bg"
                  style="left: 5%;top: 1%;"
                />
              </van-image>
            </div>
            <!-- 切换菜单 -->
            <div
              class="menu-view flx-col-ctr"
            >
              <div class="menu">
                <span
                  v-for="(item, index) in NAV_INFO"
                  :id="`menu-${item.id}`"
                  :key="index"
                  class="item"
                >
                  <van-image
                    width="2rem"
                    :src="activeNav === item.id ? item.hIcon : item.nIcon"
                    :show-error="false"
                    :show-loading="false"
                    @click="navChange(item.id)"
                  />
                </span>
              </div>
              <div
                class="tips flx-ctr abs-b"
                style="width: 100%;bottom: -30px"
              >
                <van-image
                  class="animated1d5s ani-it-inf wiperUpTips"
                  width="1.46rem"
                  :src="require('@/imgs/index/house/tips.png')"
                  :show-error="false"
                  :show-loading="false"
                />
              </div>
            </div>
          </template>
          <van-swipe
            ref="swiper1"
            class="pos-info-view"
            style="width: 10rem;height: 100vh;z-index: 10"
            :show-indicators="false"
            :width="clientWidth"
            @change="swiperChange"
          >
            <template
              v-if="pageType == PAGE_TYPE_LIST[0]"
            >
              <van-swipe-item
                v-for="(item, index) in NAV_INFO"
                :key="index"
                class="animated1s fadeIn content-item flx-col-ctr"
              >
                <template v-if="activeNav === NAV_INFO[index].id">
                  <div
                    class="abs flx-ctr"
                    style="width: 10rem;height: 100vh;"
                  >
                    <van-image
                      :src="require('@/imgs/index/house/bg.png')"
                      :show-error="false"
                      :show-loading="false"
                      width="10rem"
                      class="hide-bg"
                      style="z-index: 1000;margin-top: -24vh;"
                    >
                      <van-image
                        class="show-bg abs animated1s delay0d5s flash"
                        :src="item.pos"
                        :show-error="false"
                        :show-loading="false"
                        :width="item.posW"
                        :style="`left: ${item.pLeft}; top: ${item.pTop}`"
                      />
                    </van-image>
                  </div>
                </template>
              </van-swipe-item>
            </template>
          </van-swipe>
        </div>
      </van-swipe-item>
      <van-swipe-item class="content-item">
        <!-- 详细内容 -->
        <van-swipe
          ref="swiper"
          class="content-info-view"
          :show-indicators="false"
          :width="clientWidth"
          @change="swiperChange"
        >
          <van-swipe-item
            v-for="(item, index) in NAV_INFO"
            :key="index"
            class="content-item flx-col-ctr"
          >
            <template
              v-if="pageType == PAGE_TYPE_LIST[1]"
            >
              <!-- 背景 -->
              <van-image
                width="10rem"
                :height="showSubNav ? 'calc(100vh - 98px)' : 'calc(100vh - 54px)'"
                class="abs animated1s fadeIn"
                style="z-index: 0;"
                :src="require('@/imgs/index/house/bg2.png')"
                :show-error="false"
                :show-loading="false"
              />
              <div
                class="flx-col-arn"
                style="height: 100%"
              >
                <template v-if="activeNav == NAV_INFO[index].id">
                  <van-image
                    width="10rem"
                    class="animated1s fadeIn"
                    :src="item.title"
                    :show-error="false"
                    :show-loading="false"
                  />
                  <van-image
                    :width="item.contentW || '4.5rem'"
                    class="animated1s delay0d5s zoomIn "
                    :src="item.content"
                    :show-error="false"
                    :show-loading="false"
                    @click.stop="previewImg(item.id)"
                  >
                    <van-image
                      v-if="showTag"
                      class="abs animated1s clipCircle "
                      :style="`top: ${item.tTop};left: ${item.tLeft}`"
                      :width="item.tagW || '4.5rem'"
                      :src="item.tag"
                      :show-error="false"
                      :show-loading="false"
                      @click.stop="previewImg(item.id)"
                    />
                  </van-image>
                  <div
                    class="flx-ctr animated1s delay0d5s fadeIn"
                    style="position: relative;width: 100%;"
                  >
                    <van-image
                      width="2.4rem"
                      :src="require('@/imgs/index/house/big_tips.png')"
                      :show-error="false"
                      :show-loading="false"
                      @click.prevent="previewImg(item.id)"
                    />
                    <span class="abs-r tag-btn">
                      <van-image
                        width=".6rem"
                        :src="showTag ? require('@/imgs/index/house/bz_h.png') : require('@/imgs/index/house/bz_n.png')"
                        :show-error="false"
                        :show-loading="false"
                        @click="toggoleTag"
                      />
                    </span>
                  </div>
                  <van-image
                    width="8rem"
                    class="animated1s delay0d5s fadeInUp"
                    style="margin-bottom: 1vh"
                    :src="item.info"
                    :show-error="false"
                    :show-loading="false"
                  />
                </template>
              </div>
            </template>
          </van-swipe-item>
        </van-swipe>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { Swipe, SwipeItem, ImagePreview } from 'vant';
import { NAV_INFO } from '@/libs/config/house';

const PAGE_TYPE_LIST = ['pos', 'detail'];

export default {
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [ImagePreview.Component.name]: ImagePreview,
  },
  data() {
    return {
      PAGE_TYPE_LIST,
      NAV_INFO,
      clientWidth: 0,
      activeNav: NAV_INFO[0].id,
      pageType: 'pos', // 展示页面
      showTag: false,
    };
  },
  mounted() {
    // 正确设置swiper宽度
    this.clientWidth = document.body.clientWidth;
    const { href } = window.location;
    const index = (/type=([0-9]{1})/.exec(href) || [])[1];
    if (index) {
      this.swiperChange(parseInt(index, 10));
    }
  },
  methods: {
    toggoleTag() {
      this.showTag = !this.showTag;
    },
    // swiper组件联动nav组件
    swiperTypeChange(index) {
      this.pageType = PAGE_TYPE_LIST[index];
      this.showTag = false;
      const i = NAV_INFO.findIndex((item) => item.id === this.activeNav) || 0;
      this.$refs.swiper.swipeTo(i);
      this.$refs.swiper1.swipeTo(i);
    },
    // swiper组件下标改变
    swiperChange(index) {
      this.activeNav = NAV_INFO[index].id;
      this.showTag = false;
      this.$refs.swiper.swipeTo(index);
      this.$refs.swiper1.swipeTo(index);
      // this.scrollIntoView(NAV_INFO[index].id);
    },
    // 菜单改变
    navChange(id) {
      this.activeNav = id;
      const index = NAV_INFO.findIndex((item) => item.id === id) || 0;
      this.$refs.swiper.swipeTo(index);
      this.$refs.swiper1.swipeTo(index);
      this.showTag = false;
      // this.scrollIntoView(id);
    },
    // 预览大图
    previewImg(id) {
      console.log(id);
      const imgs = {
        A: [require('@/imgs/index/house/A_big.png')],
        B: [require('@/imgs/index/house/B_big.png')],
        C: [require('@/imgs/index/house/B_big.png')],
        D: [require('@/imgs/index/house/D_big.png')],
        E: [require('@/imgs/index/house/E_big.png')],
      };
      ImagePreview({
        images: imgs[id],
        showIndex: false,
        overlayStyle: {
          background: '#0f1720',
        },
      });
    },
    scrollIntoView(id) {
      this.$nextTick(() => {
        document.getElementById(`menu-${id}`).scrollIntoView({ behavior: 'smooth' });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.house-page {
  .content-page-view {
    height: 100vh;
    &.content-item {
      height: 100vh;
    }
    .bg {
      position: relative;
      width: 100%;
      height: calc(100vh - 224px);
    }
  }
  .content-info-view {
    width: 100%;
    height: calc(100% - 54px);
    .content-view {
      width: 100%;
    }
  }
  .pos-info-view {
    width: 100%;
    height: 100%;
    & .content-item {
      width: 100%;
      height: 100%;
    }
  }
  .tag-btn {
    z-index: 10;
    right: 1rem;
    padding: 3px 14px;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 50px;
  }
  .menu-view {
    position: absolute;
    bottom: 79px;
    left: 0;
    width: 10rem;
    height: 110px;
    padding: 14px 0;
    background-color: #1f1d1f;
    z-index: 2000;
    // margin-top: 4vh;
    .menu {
      width: 94%;
      overflow-x: scroll;
      white-space: nowrap;
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      .item {
        margin-right: 13px;
        &:last-child {
          margin: 0;
        }
      }
    }
  }
  .blur-bg {
    width: 20rem;
    height: calc(100vh - 54px);
    filter: blur(5px);
  }
  .hide-bg /deep/ img {
    opacity: 0;
  }
  .show-bg /deep/ img {
    opacity: 1 !important;
  }
}
</style>
